import { Link } from 'react-router-dom';
import { Mail, ExternalLink, MessageCircle } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[hsl(120,10%,18%)] text-white py-12 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://aiays.org/wp-content/uploads/2024/01/Untitled-13.png" 
                alt="Logo" 
                className="h-10 w-auto brightness-200"
              />
              <span className="text-xl font-semibold" style={{ fontFamily: 'Playfair Display, serif' }}>
                Ayurveda Consult
              </span>
            </div>
            <p className="text-stone-400 text-sm mb-4">
              Ancient wisdom meets modern technology. Personalized Ayurvedic consultations powered by AI and verified by experts.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-[hsl(43,70%,52%)]">Quick Links</h4>
            <ul className="space-y-2 text-stone-400 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/dashboard" className="hover:text-white transition-colors">My Dashboard</Link>
              </li>
              <li>
                <Link to="/panchkarma" className="hover:text-white transition-colors">Panchkarma Centers</Link>
              </li>
              <li>
                <a href="/#faq" className="hover:text-white transition-colors">FAQs</a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-4 text-[hsl(43,70%,52%)]">Resources</h4>
            <ul className="space-y-2 text-stone-400 text-sm">
              <li>
                <a href="https://aiays.org" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors flex items-center gap-1">
                  AIAYS Institute <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a href="/#faq" className="hover:text-white transition-colors">What is Ayurveda?</a>
              </li>
              <li>
                <a href="/#faq" className="hover:text-white transition-colors">Understanding Doshas</a>
              </li>
              <li>
                <a href="https://aiays.org/blog" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors flex items-center gap-1">
                  Blog & Articles <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-[hsl(43,70%,52%)]">Contact Us</h4>
            <ul className="space-y-3 text-stone-400 text-sm">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-[hsl(22,70%,44%)]" />
                <a href="mailto:me@ayurvedaconsult.online" className="hover:text-white transition-colors">me@ayurvedaconsult.online</a>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle className="w-4 h-4 text-[hsl(135,15%,33%)]" />
                <a href="https://wa.me/61450605321" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">+61 450 605 321</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-stone-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-stone-400 text-sm">
              © 2025 Ayurveda Consult. Ancient wisdom, modern technology.
            </p>
            <div className="flex items-center gap-6 text-stone-400 text-sm">
              <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/disclaimer" className="hover:text-white transition-colors">Terms & Disclaimer</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
